<template>
  <div>
    <!-- route to popup [[src/components/dialog/creatorProgram/Business.vue]] -->
    <!-- All popups will appear here -->
    <router-view />

    <layout-logged-frame
      :title="$t('creator_program_businesses')"
      :total-count="pagination.totalItems"
    >
      <template v-slot:header-actions>
        <Can action="store" subject="loyalty_program">
          <v-btn
            color="primary"
            @click="openNewBusinessModal"
          >
            <v-icon> add </v-icon>
            {{ $t('add_new_business') }}
          </v-btn>
        </Can>
      </template>

      <template v-slot:content>
        <BusinessesFilters @filter="onFilter" @clearFilters="onClearFilters" />

        <BusinessesTable
          :items="businesses"
          :pages="totalPages"
          :pagination="pagination"
          :is-loading="isLoading"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import {isStr} from '@/utils';
import BusinessesFilters from '../../components/forms/filters/Businesses';
import BusinessesTable from '../../components/table/Businesses';

export default {
  components: {
    BusinessesFilters,
    BusinessesTable
  },
  data() {
    return {
      pagination: {
        order: 'desc' ,
        page: 1,
        rowsPerPage: 15,
        sortBy: 'created_at',
        totalItems: 0,
        search: '',
      },
      totalPages: 0,
      query: {
        per_page: 15,
      },
      isLoading: false,
    };
  },
  computed: {
    businesses() {
      return this.$store.getters['creatorProgram/businesses'];
    },
    currentRoute() {
      return this.$route;
    },
  },
  watch: {
    currentRoute (to, from){
      if (
        (from.name === 'creator-program-businesses-new' ||
        from.name === 'creator-program-businesses-details') &&
        to.name === 'creator-program-businesses' &&
        to.query?.status === 'success'
      ) {
        this.getItems(this.query);
      }
    }
  },
  methods: {
    getItems(query) {
      this.isLoading = true;
      this.pagination.order = query.order;

      return this.$store
        .dispatch('creatorProgram/getBusinesses', query)
        .then((res) => {
          const { businessesMeta } = res;
          const { total, current_page, last_page } = businessesMeta;

          this.pagination.page = current_page;
          this.pagination.totalItems = total;
          this.totalPages = last_page;
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    selectItem(business) {
      this.$store.dispatch('creatorProgram/setActiveBusiness', business).then(() => {
        this.$router.push({name: 'creator-program-businesses-details', params: {id: business.id}});
      });
    },
    onUpdatePagination({ page, order, sortBy }) {
      const { query, pagination } = this;
      this.pagination.order = order;
      this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

      const nextQuery = {
        ...query,
        page,
        order,
        sort: isStr(sortBy) ? sortBy : pagination.sortBy,
      };

      this.query = nextQuery;
      this.getItems(nextQuery);
    },
    onChangePage(page) {
      const { query, pagination } = this;
      const { order, sortBy } = pagination;
      const nextQuery = {
        ...query,
        page,
        order,
        sort: sortBy,
      };

      this.query = nextQuery;
      this.getItems(nextQuery);
    },
    onFilter({ search, labels, countries, status, dates }) {
      this.query = {
        ...this.query,
        page: 1,
        search: search || undefined,
        dates: dates || undefined,
        status: status != null ? status : undefined,
        labels,
        countries,
      };

      this.getItems(this.query);
    },
    onClearFilters() {
      const { sortBy, order } = this.pagination;
      this.query = { sort: sortBy, order, per_page: 15, page: 1 };
      this.getItems(this.query);
    },
    openNewBusinessModal() {
      this.$router.push({name: 'creator-program-businesses-new'});
    },
  },
};
</script>
